(function () {
  if (window.__pdpWatermelonCampaignReady) return;
  window.__pdpWatermelonCampaignReady = true;

  const WATERMELON_VALUE = 'watermelon';
  const VARIANT_BODY_CLASS = 'watermelon-variant-active';
  const CART_BODY_CLASS = 'cart-has-watermelon-item';

  const LP1 = {
    sectionSelector: '.eit',
    headingSelector: '.eit__heading',
    headings: [
      'Designed for days you don\u2019t want to end.',
      'With the help of natural ingredients.',
    ],
    originalDataKey: 'watermelonOriginal',
  };

  const CAFFEINE_COPY = {
    selector: 'p',
    match: 'caffeine',
    pattern: /40(\s*mg)/i,
    replacement: '20$1',
    originalDataKey: 'watermelonCaffeine',
  };

  const SUPPLEMENT_FACTS = {
    detailsSelector: '.accordion-details',
    headingSelector: '.accordion-details__heading',
    headingMatch: 'supplement facts',
    imageSelector: '.accordion-details__image img',
    srcKey: 'watermelonSupplementSrc',
    srcsetKey: 'watermelonSupplementSrcset',
  };

  const WAVE_OVERLAY = {
    sectionSelector: '[id*="__neuro_wave_"]',
    overlayClass: 'watermelon-wave-overlay',
    baseFill: '#F5426E',
    // Same shape/height as the base wave so the green only shows as a top band,
    // never extending below the pink wave's bottom edge.
    markup:
      '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" viewBox="0 0 1440 148" fill="none" preserveAspectRatio="none" aria-hidden="true">' +
      '<path d="M746.069 34.7558C1011.26 -44.6373 1266.65 20.0885 1440 146.949V149.534H0V37.0683C179.258 139.277 445.29 136.208 746.069 34.7558Z" style="fill:#92D500"/>' +
      '</svg>',
  };

  const REBUY_SMARTCART_EVENTS = [
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show',
    'rebuy:smartcart.line-item-increase',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.line-item-removed',
  ];

  const getProductInfo = () =>
    document.querySelector('product-info[data-watermelon-campaign="true"]');

  const getWatermelonVariantId = () => {
    const raw = getProductInfo()?.dataset.watermelonVariantId;
    const id = Number(raw);
    return Number.isFinite(id) && id > 0 ? id : null;
  };

  const isWatermelonVariant = (variant) =>
    Array.isArray(variant?.options) &&
    variant.options.some(
      (opt) => typeof opt === 'string' && opt.trim().toLowerCase() === WATERMELON_VALUE
    );

  const applyLp1IngredientsCopy = (isActive) => {
    document.querySelectorAll(LP1.sectionSelector).forEach((section) => {
      section.querySelectorAll(LP1.headingSelector).forEach((heading, index) => {
        const { dataset } = heading;
        const hasOriginal = LP1.originalDataKey in dataset;
        if (isActive) {
          if (!hasOriginal) dataset[LP1.originalDataKey] = heading.textContent;
          const replacement = LP1.headings[index];
          if (replacement) heading.textContent = replacement;
        } else if (hasOriginal) {
          heading.textContent = dataset[LP1.originalDataKey];
          delete dataset[LP1.originalDataKey];
        }
      });
    });
  };

  const applyCaffeineCopy = (isActive) => {
    document.querySelectorAll(CAFFEINE_COPY.selector).forEach((paragraph) => {
      if (!paragraph.textContent.toLowerCase().includes(CAFFEINE_COPY.match)) return;
      const { dataset } = paragraph;
      const hasOriginal = CAFFEINE_COPY.originalDataKey in dataset;
      if (isActive) {
        if (!hasOriginal) dataset[CAFFEINE_COPY.originalDataKey] = paragraph.innerHTML;
        paragraph.innerHTML = paragraph.innerHTML.replace(
          CAFFEINE_COPY.pattern,
          CAFFEINE_COPY.replacement
        );
      } else if (hasOriginal) {
        paragraph.innerHTML = dataset[CAFFEINE_COPY.originalDataKey];
        delete dataset[CAFFEINE_COPY.originalDataKey];
      }
    });
  };

  const applySupplementFacts = (isActive) => {
    const newSrc = getProductInfo()?.dataset.watermelonSupplementImage;
    if (!newSrc) return;
    document.querySelectorAll(SUPPLEMENT_FACTS.detailsSelector).forEach((details) => {
      const heading = details.querySelector(SUPPLEMENT_FACTS.headingSelector);
      if (!heading || !heading.textContent.trim().toLowerCase().includes(SUPPLEMENT_FACTS.headingMatch)) {
        return;
      }
      const image = details.querySelector(SUPPLEMENT_FACTS.imageSelector);
      if (!image) return;
      const { dataset } = image;
      if (isActive) {
        if (!(SUPPLEMENT_FACTS.srcKey in dataset)) {
          dataset[SUPPLEMENT_FACTS.srcKey] = image.getAttribute('src') || '';
          dataset[SUPPLEMENT_FACTS.srcsetKey] = image.getAttribute('srcset') || '';
        }
        image.removeAttribute('srcset');
        image.setAttribute('src', newSrc);
      } else if (SUPPLEMENT_FACTS.srcKey in dataset) {
        image.setAttribute('src', dataset[SUPPLEMENT_FACTS.srcKey]);
        if (dataset[SUPPLEMENT_FACTS.srcsetKey]) {
          image.setAttribute('srcset', dataset[SUPPLEMENT_FACTS.srcsetKey]);
        }
        delete dataset[SUPPLEMENT_FACTS.srcKey];
        delete dataset[SUPPLEMENT_FACTS.srcsetKey];
      }
    });
  };

  const applyWaveOverlay = (isActive) => {
    const section = document.querySelector(WAVE_OVERLAY.sectionSelector);
    if (!section) return;

    const basePath = section.querySelector(':scope > svg > path');
    if (basePath) basePath.style.fill = isActive ? WAVE_OVERLAY.baseFill : '';

    const existing = section.querySelector('.' + WAVE_OVERLAY.overlayClass);
    if (isActive) {
      if (existing) return;
      const overlay = document.createElement('div');
      overlay.className = WAVE_OVERLAY.overlayClass;
      overlay.innerHTML = WAVE_OVERLAY.markup;
      section.appendChild(overlay);
    } else if (existing) {
      existing.remove();
    }
  };

  const applyState = (isActive) => {
    document.body.classList.toggle(VARIANT_BODY_CLASS, isActive);
    applyLp1IngredientsCopy(isActive);
    applyCaffeineCopy(isActive);
    applySupplementFacts(isActive);
    applyWaveOverlay(isActive);
  };

  document.addEventListener('variant:changed', (event) => {
    if (!getProductInfo()) return;
    applyState(isWatermelonVariant(event.detail?.variant));
  });

  const initialVariantCheck = () => {
    const productInfo = getProductInfo();
    if (!productInfo) return;
    const selectedVariantNode = productInfo.querySelector('[data-selected-variant]');
    if (!selectedVariantNode) return;
    try {
      applyState(isWatermelonVariant(JSON.parse(selectedVariantNode.textContent)));
    } catch (_) {}
  };

  const syncCartBodyClass = (smartcart) => {
    const watermelonVariantId = getWatermelonVariantId();
    const items = smartcart?.cart?.items;
    if (!watermelonVariantId || !Array.isArray(items)) return;
    const hasWatermelon = items.some(
      (item) => Number(item?.variant_id ?? item?.variantId ?? item?.id) === watermelonVariantId
    );
    document.body.classList.toggle(CART_BODY_CLASS, hasWatermelon);
  };

  REBUY_SMARTCART_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, (event) => syncCartBodyClass(event.detail?.smartcart));
  });

  const init = () => {
    initialVariantCheck();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
